import { useEffect, useState } from "react"
import { Currency, useGetCompanyCurrencyPublicQuery } from "../generated/graphql"

export type CurrencySettings = {
    long: string
    short: string
    symbol: string
    decimalSeperator: string
}

const currencyTranslations: { [key: string]: CurrencySettings } = {
    Chf: {
        long: "Schweizer Franken",
        short: "CHF",
        symbol: "CHF",
        decimalSeperator: ".",
    },
    Eur: {
        long: "Euro",
        short: "EUR",
        symbol: "€",
        decimalSeperator: ",",
    },
}

export const useCurrency = (): CurrencySettings => {
    const [currency, setCurrency] = useState<Currency>(Currency.Eur)
    const [currencySettings, setCurrencySettings] = useState<CurrencySettings>({
        long: currencyTranslations.Eur.long,
        short: currencyTranslations.Eur.short,
        symbol: currencyTranslations.Eur.symbol,
        decimalSeperator: currencyTranslations.Eur.decimalSeperator,
    })

    const { data: appSettings } = useGetCompanyCurrencyPublicQuery()

    const currencySetting: Currency = appSettings?.companyCurrencyPublic.currency
        ? Currency[appSettings.companyCurrencyPublic.currency]
        : Currency.Eur

    useEffect(() => {
        setCurrency(currencySetting)
        setCurrencySettings({
            long: currencyTranslations[currencySetting].long,
            short: currencyTranslations[currencySetting].short,
            symbol: currencyTranslations[currencySetting].symbol,
            decimalSeperator: currencyTranslations[currencySetting].decimalSeperator,
        })
    }, [currency, currencySetting])

    return currencySettings
}
